"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("../state/state"));
exports.default = (function (e) {
    if (e.target.matches('#size1')) {
        state_1.default.sizeState.name = '15cm';
        state_1.default.sizeState.size = 1;
    }
    else if (e.target.matches('#size2')) {
        state_1.default.sizeState.name = '30cm';
        state_1.default.sizeState.size = 2;
    }
});
